export const API_MAP_KEY = "AIzaSyAxSLla7466yr8fj86bMiXza8a6QU3DtrY";

export const PLACES_AUTOCOMPLETE_OPTIONS = {
  types: ["geocode"],
  fields: ["address_components", "geometry", "formatted_address", "place_id"],
};

export async function geocodeAddress(address) {
  const query = address?.trim();
  if (!query) return null;

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    query
  )}&key=${API_MAP_KEY}`;

  const response = await fetch(url);
  const data = await response.json();

  if (data.status !== "OK" || !data.results?.length) {
    return null;
  }

  const result = data.results[0];
  return {
    formatted_address: result.formatted_address,
    lat: result.geometry.location.lat,
    lng: result.geometry.location.lng,
  };
}

export function applyGeocodedPlace(result, setStoreAddress, setLocationX, setLocationY) {
  if (!result) return false;
  setStoreAddress(result.formatted_address);
  setLocationX(result.lat);
  setLocationY(result.lng);
  return true;
}
